import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

const EditCustomer = ({ userDetails, CloseDetailUser, userUpdate }) => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, SetSharedObject } = useUserStore(
    (state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [answers, setAnswers] = useState(null);
  const [name, setName] = useState(null);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const [processing, SetProcessing] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);

  const [inputPhoneValue, setInputPhoneValue] = useState("");
  const handlePhoneInput = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setInputPhoneValue(formattedPhoneNumber);
  };
  const ClearFields = async () => {
    let o = {};
    if (userDetails?.billingAddressId) {
      var date = new Date("Tue Jul 12 2011 16:00:00 GMT-0700");
      var dateStrToSendToServer = date.toISOString();
      o = {
        Id: userDetails.billingAddressId,
        AlternatePhone: userDetails.billingAddress.alternatePhone,
        City: userDetails.billingAddress.city,
        Country: userDetails.billingAddress.country,
          Fax: formatPhoneNumber(userDetails.billingAddress.fax?.substring(0, 10)),
        FaxExt: userDetails.billingAddress.fax?.substring(
          10,
          userDetails.billingAddress.fax.length
        ),
        Phone: formatPhoneNumber(userDetails.billingAddress.phone?.substring(0, 10)),
        PhoneExt: userDetails.billingAddress.phone?.substring(
          10,
          userDetails.billingAddress.phone.length
        ),
        State: userDetails.billingAddress.state,
        Street1: userDetails.billingAddress.street1,
        Street2: userDetails.billingAddress.Street2,
        ZIP: userDetails.billingAddress.zip,
        IsCertAddress: false,
        CreatedBy: userRole,
        ModifiedBy: userRole,
        DateModified: dateStrToSendToServer,
        SystemCreated: dateStrToSendToServer,
        SystemModified: userRole,
      };
      }
    setAnswers(o);
  };
  useEffect(() => {
    setName(userDetails);
    ClearFields();
    return () => {
      ClearFields();
    };
  }, [userDetails]);
  const updateUser = async () => {
    SetFrmSubmFlag(true);
    //SetProcessing(true);
    if (!answers.Street1) {
      document.getElementById("Street1").scrollIntoView();
      document.getElementById("Street1").focus();
      return;
    } else if (!answers.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.ZIP) {
      document.getElementById("ZIP").scrollIntoView();
      document.getElementById("ZIP").focus();
      return;
    } else if (!answers.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }
      var phone = answers.Phone?.replace(/[^0-9]/g, "").substring(0, 10);
      var fax = answers.Fax?.replace(/[^0-9]/g, "").substring(0, 10);
      if (phone.length < 10) {
          document.getElementById("Phone").scrollIntoView();
          document.getElementById("Phone").focus();
          return;
      }
      if (fax.length > 0 && fax.length < 10) {
          document.getElementById("Fax").scrollIntoView();
          document.getElementById("Fax").focus();
          return;
      }
      SetFrmSubmFlag(false);
    answers.Phone =
      phone + answers.PhoneExt;
    answers.Fax =
      fax + answers.FaxExt;
    let call = "/customers/UpdateCustomerAddress";
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let obj = {
        alternatePhone: answers.AlternatePhone,
        city: answers.City,
        country: answers.Country,
        county: answers.County,
        fax: answers.Fax,
        id: answers.Id,
        phone: answers.Phone,
        state: answers.State,
        street1: answers.Street1,
        street2: answers.Street2,
        zip: answers.ZIP,
      };
      userUpdate({ ...userDetails, billingAddress: obj });
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
      $("#editCustomerModal").modal("hide");
    }
  };
  return (
    <div className="EditCustomer">
      <div
        className="modal fade"
        id="editCustomerModal"
        data-backdrop="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsCustomer"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                Edit Details
              </div>
              <button
                type="button"
                className="close"
                onClick={(e) => {
                  CloseDetailUser();
                  ClearFields();
                }}
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <form className="needs-validation" noValidate>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header">
                    <i className="bi bi-buildings-fill text-size5 blk-clr"></i>
                    <div className="text-size6 ft-wt blk-clr spacer-margin7">
                      {name?.name}
                    </div>
                  </div>
                  <hr />
                  {/* <div className="field-wrapper">
                    <label for="CustomerID">Customer Name</label>
                    <input className="form-control" />
                    <div className="alert alert-danger" hidden>
                      Customer name is required.
                    </div>
                  </div> */}
                  {/*Address 1*/}
                  <div className="field-wrapper">
                    <label for="Street1">Address 1</label>
                    <input
                      className="form-control"
                      name="Street1"
                      id="Street1"
                      value={answers?.Street1}
                      onChange={(el) => setAnswer("Street1", el.target.value)}
                    />
                    {!answers?.Street1 && frmSubmFlag ? (
                      <div className="alert alert-danger">
                        Address is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 2*/}
                  <div className="field-wrapper">
                    <label for="Street2">Address 2</label>
                    <input
                      className="form-control"
                      name="Street2"
                      placeholder="Optional"
                      value={answers?.Street2}
                      onChange={(el) => setAnswer("Street2", el.target.value)}
                    />
                  </div>
                  <div className="field-wrapper">
                    <label for="city">City</label>
                    <input
                      className="form-control"
                      name="City"
                      id="City"
                      value={answers?.City}
                      onChange={(el) => setAnswer("City", el.target.value)}
                    />
                    {!answers?.City && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          City is required.
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper">
                    {/*State*/}
                    <div className="field-box1 field-ext">
                      <label for="State">State</label>
                      <select
                        className="form-control"
                        name="State"
                        id="State"
                        value={answers?.State}
                        onChange={(el) => setAnswer("State", el.target.value)}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*Zip Code*/}
                    <div className="field-box1 field-ext">
                      <label for="ZIP">Zip</label>
                      <input
                        className="form-control"
                        id="ZIP"
                        name="ZIP"
                        value={answers?.ZIP}
                        onChange={(el) => setAnswer("ZIP", el.target.value)}
                      />
                    </div>
                    {!answers?.State && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          State selecion is required.
                        </div>
                      </div>
                    ) : null}
                    {!answers?.ZIP && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div className="alert alert-danger">
                          Zip Code is required.
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {/*Phone*/}
                  <div className="field-wrapper ">
                    <div className="field-box1">
                      <label for="Phone">Phone</label>
                      <input
                        className="form-control"
                        id="Phone"
                        name="Phone"
                        value={formatPhoneNumber(answers?.Phone)}
                        onChange={(el) => setAnswer("Phone", el.target.value)}
                      />
                      {!answers?.Phone && frmSubmFlag ? (
                      <div className="alert alert-danger">
                        Phone number is required.
                      </div>
                    ) : null}
                    
                    {answers?.Phone && (answers?.Phone?.length < 14)  && frmSubmFlag ? (
                        <div className="alert alert-danger">Invalid Phone Number</div>
                    ): null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label for="PhoneExt">Ext</label>
                      <input
                        className="form-control"
                        name="PhoneExt"
                        type="number"
                        maxLength={6}
                        value={answers?.PhoneExt}
                        onChange={(elx) => {
                          let vl = elx.target.value;
                          if (vl.length < 7) {
                            setAnswer("PhoneExt", vl);
                          }
                        }}
                      />
                    </div>
                  </div>
                  {/*Fax*/}
                  <div className="field-wrapper">
                    <div className="field-box1">
                      <label for="Fax">Fax</label>
                      <input
                        className="form-control"
                        name="Fax"
                        id="Fax"
                        value={formatPhoneNumber(answers?.Fax)}
                        placeholder="Optional"
                        onChange={(el) => setAnswer("Fax", el.target.value)}
                      />
                    {(answers?.Fax?.length < 14 && answers?.Fax.length > 0)  && frmSubmFlag ? (
                      <div className="alert alert-danger">Invalid Fax Number</div>) :null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label for="FaxExt">Ext</label>
                      <input
                        className="form-control"
                        name="FaxExt"
                        type="number"
                        maxLength={6}
                        value={answers?.FaxExt}
                        onChange={(el) => {
                          let vl = el.target.value;
                          if (vl.length < 7) {
                            setAnswer("FaxExt", el.target.value);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/*Processing Spinner*/}
                {processing ? <div className="loading-edit"></div> : null}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updateUser}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={(e) => {
                    CloseDetailUser();
                    ClearFields();
                    SetFrmSubmFlag(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCustomer;
